<template>
  <div class="interiorContainer">
    <leftPublicTree type="interior" :updatePersonList="updatePersonList"></leftPublicTree>
    <rightPublicTable type="interior" ref="rightPublicTable"></rightPublicTable>
  </div>
</template>

<script>
import leftPublicTree from '../components/leftPublicTree'
import rightPublicTable from '../components/rightPublicTable'
export default {
  name:'interior',

  components : {
    leftPublicTree,
    rightPublicTable
  },

  methods : {
    updatePersonList (data) {
      this.$refs.rightPublicTable.updateList(data)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .interiorContainer
    width 100%
    height 100%
    margin-top 14px
    display flex
    align-items center
    background #fff
</style>
